import React, {Component} from 'react';
import Login from '../components/login/Login'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom';
import Storage from '../services/Storage';
import queryString from 'query-string';
import {SpinnerModal} from "../public/components/SpinnerModal";


export function withAuthentication(Comp) {

  class Authentication extends Component {

      componentDidMount(){
        this.props.dispatchFetchFrontendConfig();
      }

      render() {

        const {frontendConfig} = this.props;

        if (!frontendConfig || !frontendConfig['ddp-login-url']){
          return <SpinnerModal visible={true}/>;
        }

        const userState = this.props.authentication;
        const {pathname, search} = this.props.location;
        const params = queryString.parse(search);

        const token = Storage.getItem('token');

        const loggedIn = userState.userState === 'signed-in' || token !== undefined;
        const loginFailure = userState.userState === 'auth-failure';

        const isLoginPage = pathname === '/login';

        if (!loggedIn && (!isLoginPage || loginFailure) ){
          //window.location.replace('https://www.bmw-dealer-development.net/CfD2/Content/System/Text.aspx?i=MTk2');
          window.location.replace(frontendConfig['ddp-login-url']);
          return null;
        }
        if (isLoginPage && loggedIn && !search.token){
          this.props.history.push("/");
        }
          return (
            (isLoginPage && (!loggedIn || params.token)) ? <Login {...this.props}/> :
              <Comp
                  {...this.props}/>
          )
      }
  }

  function mapStateToProps (state) {
    return {
      authentication: state.authentication,
      frontendConfig: state.frontendConfig,
    }
  }

  const mapDispatchToProps = dispatch => ({
    dispatchFetchFrontendConfig: () => dispatch({type: 'FETCH_FRONTEND_CONFIG.REQUEST'}),
  });

  return withRouter(connect(mapStateToProps, mapDispatchToProps)(Authentication));

}

const mapStateToProps = state => ({
  frontendConfig: state.frontendConfig,
});



export default connect(
  mapStateToProps,
)(withAuthentication);
